function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fill: "#969EA2",
  d: "M4 0h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4zm6.208 5.76a.863.863 0 00-.62.263L4.39 11.349a.903.903 0 000 1.257l5.243 5.372a.863.863 0 001.236.003.903.903 0 00.003-1.26l-4.63-4.743 4.586-4.699a.903.903 0 00-.003-1.26.863.863 0 00-.616-.259zm3.584 0a.863.863 0 00-.616.26.903.903 0 00-.003 1.26l4.586 4.698-4.63 4.743a.903.903 0 00.003 1.26.863.863 0 001.236-.003l5.243-5.372a.903.903 0 000-1.257l-5.2-5.326a.863.863 0 00-.619-.263z"
})));